"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
const tools_1 = require("../outils/tools");
const boutons_1 = require("../outils/boutons");
class StdGrid extends webix_jet_1.JetView {
    constructor(app, name, conf) {
        super(app, name);
        this.moduleName = conf.moduleName;
        this.datatableName = conf.datatableName;
        this.urlData = conf.urlData;
        this.saveData = conf.saveData;
        this.rules = conf.rules;
        this.multiselect = conf.multiselect;
        this.title = conf.title;
        this.columns = conf.columns;
        this.boutons = conf.boutons;
        this.searchFieldHint = conf.searchFieldHint;
    }
    config() {
        const tt = {
            rows: [
                // this.stdToolBar ,
                {
                    view: "toolbar", id: "listMenu",
                    elements: [
                        {
                            height: 32, borderless: true, template: this.title,
                            css: "webix_header app_header", width: 300
                        },
                        {
                            view: "menu", localId: "stdGridMenu",
                            data: this.boutons,
                            width: 400
                        },
                        {
                            view: "search", placeholder: this.searchFieldHint,
                            id: "search", width: 200, height: 32, hidden: true,
                            attributes: { lv2: "gridSearchField" } // pour Watir uniquement
                        }, {
                            id: "actualiserButton", "view": "icon", tooltip: (0, globals_1._)("Actualiser"),
                            icon: "mdi mdi-reload", "value": "",
                            click: () => this.reload(),
                            attributes: { lv2: "gridReload" } // pour Watir uniquement
                        }, {
                            id: "imprimerTableDistantButton",
                            view: "icon", icon: "mdi mdi-file-pdf-box", tooltip: (0, globals_1._)("Générer pdf"),
                            click: () => this.imprimerTableDistant(), hidden: true
                        },
                        {
                            view: "icon",
                            icon: "mdi mdi-table-arrow-down",
                            id: "articlesImprimerTableButton",
                            value: "",
                            tooltip: (0, globals_1._)("Générer pdf depuis la liste"),
                            click: () => (0, tools_1.imprimerTable)(this.datatableName, this.title),
                            hidden: true
                        },
                        (0, boutons_1.preferencesAffichage)(this.datatableName, this.columns),
                        (0, boutons_1.supprimerPreferences)(this.datatableName, this.columns)
                    ]
                },
                {
                    view: "datatable",
                    css: "webix_header_border webix_data_border",
                    undo: true,
                    resizeColumn: { headerOnly: true },
                    // headermenu : true,   ne marche qu'en PRO
                    // select : "multiselect",
                    id: this.datatableName,
                    // select : "cell",  // obligatoire pour avoir les autres chamsp de la ligne en rouge en cas d'erreur
                    select: "row",
                    multiselect: this.multiselect,
                    editable: true, editaction: "custom",
                    dragColumn: true, sort: "multi",
                    on: {
                        onBeforeLoad: function () {
                            this.showOverlay("<h2>" + (0, globals_1._)("Chargement en cours ...") + "</h2>");
                        },
                        onItemClick: function (id) {
                            let mName = this.$scope.moduleName + ".update";
                            if (((globals_1.lv2.droits).includes(mName))) {
                                // this.editStop();
                                this.editCell(id.row, id.column);
                            }
                        },
                        onAfterEditStart: function () {
                            let ml = this.getEditor().config.maxlength;
                            if (ml > 0) {
                                this.getEditor().getInputNode().setAttribute("maxlength", ml);
                            }
                        },
                        onBlur: function (view) {
                            // webix.message("blur");
                            let vv = "state" + view.config.id;
                            webix.storage.local.put(vv, this.getState());
                        },
                        onAfterLoad: function () {
                            let vv = this.$scope.getRoot();
                            let view = $$(vv.config.$scope.datatableName);
                            let v2 = "state" + view.config.id;
                            const state = webix.storage.local.get(v2);
                            // Désactivation pendant le développement
                            if (state)
                                this.setState(state);
                            this.hideOverlay();
                        }
                    },
                    columns: this.columns,
                    url: this.urlData,
                    save: this.saveData,
                    rules: this.rules
                }
            ]
        };
        return tt;
    }
    imprimerTableDistant() {
        webix.message((0, globals_1._)("Génération du fichier pdf en cours"));
        // @ts-ignore
        webix.ajax().response("blob").get(globals_1.phpPath + "/printing/articles.php", function (text, data) {
            // @ts-ignore
            webix.html.download(data, this.title + ".pdf");
        });
    }
    setDefaultValues(record) { }
    reload() {
        this.currentGrid.editStop();
        this.currentGrid.clearAll();
        this.currentGrid.load(this.currentGrid.config.url);
        if (this.searchField) {
            this.searchField.setValue("");
        }
    }
    ajouter() {
        let data = { "unid": 0 };
        // let vv = this.$scope.getRoot();
        let view = this.currentGrid;
        view.editStop();
        let index = 0;
        if (view.getSelectedId(false, false)) {
            index = view.getIndexById(view.getSelectedId(false, false));
        }
        view.add(data, index);
        view.unselectAll();
    }
    /**
     *
     * @param aEffacer as string Nom du champ à effacer et à qui donner le focus
     */
    dupliquer(aEffacer) {
        let view = this.currentGrid;
        view.editStop();
        if (!view.getSelectedId(false, false)) {
            webix.message((0, globals_1._)("Aucune ligne n'est sélectionnée"));
            return; //'data' is an ID of the needed component
        }
        this.duplicating = true; // pour éviter les valeurs par défaut
        let index = view.getIndexById(view.getSelectedId(false, false));
        let data = view.getSelectedItem();
        let ndata = webix.copy(data);
        ndata["unid"] = "";
        ndata["id"] = webix.uid();
        ndata[aEffacer] = "";
        view.clearSelection();
        view.add(ndata, index);
        view.select(ndata["id"], false);
        view.editCell(ndata["id"], aEffacer);
    }
    supprimer() {
        let view = this.currentGrid;
        let selected = view.getSelectedId(true, false);
        if (selected.length < 1) {
            webix.message((0, globals_1._)("Aucune ligne n'est sélectionnée"));
            return;
        }
        let msg = (0, globals_1._)("Veuillez confirmer la suppression de cette ligne");
        // cas d'une sélection multiple
        if (selected.length > 1) {
            msg = (0, globals_1._)("Veuillez confirmer la suppression des lignes sélectionnées : ") + selected.length;
        }
        webix.confirm({
            title: (0, globals_1._)("Confirmation"),
            text: msg,
            ok: (0, globals_1._)("OK"),
            cancel: (0, globals_1._)("Annuler")
        }).then(function () {
            view.editStop();
            for (let i = 0; i < selected.length; i++) {
                view.remove(selected[i].row);
            }
        });
    }
    supprimerDocuments() {
        let view = this.currentGrid;
        let selected = view.getSelectedId(true, false);
        globals_1.lv2.trace("Nombre de sélectionnés:" + selected.length);
        if (selected.length < 1) {
            webix.message((0, globals_1._)("Aucune ligne n'est sélectionnée"));
            return;
        }
        let msg = (0, globals_1._)("Veuillez confirmer la suppression de ce document");
        // cas d'une sélection multiple
        if (selected.length > 1) {
            msg = (0, globals_1._)("Veuillez confirmer la suppression de ces documents : ") + selected.length;
        }
        webix.confirm({
            title: (0, globals_1._)("Confirmation"),
            text: msg,
            cancel: (0, globals_1._)("Annuler"),
            ok: (0, globals_1._)("OK")
        }).then(function () {
            for (let i = 0; i < selected.length; i++) {
                let idRow = selected[i].row;
                let ligne = view.getItem(idRow);
                let idDocument = ligne.unid;
                view.remove(idRow);
                // TODO voir s'il est possible de paramétrer l'appel du php suivant
                // @ts-ignore
                let promise = webix.ajax().get(globals_1.phpPath + "factures.php?option=delete&unid=" + idDocument);
                promise.then(function (result) {
                    if (result.json().success == false) {
                        webix.alert(result.json().message);
                        return;
                    }
                    webix.message((0, globals_1._)("Document supprimé"));
                });
                promise.catch(function () {
                    webix.alert((0, globals_1._)("Erreur de suppression du document"));
                });
            }
        });
    }
    imprimerTable(title) {
        webix.message((0, globals_1._)("Génération du fichier pdf en cours"));
        webix.toPDF(this.currentGrid), {
            docHeader: title,
            filterHTML: true,
            // orientation: "landscape",
            fontName: "Roboto",
            fontURL: globals_1.phpPath + "Roboto-Regular.ttf",
            boldFontURL: globals_1.phpPath + "Roboto-Bold.ttf",
            autowidth: true, // il s'agit de la largeur globale
            // table : {			// réduit la police mais n'ajuste pas la largeur des colonnes
            // 	fontSize : 8,
            // 	autowidth:true,		// la suite ne marche pas, voir
            // https://forum.webix.com/discussion/6364/datatable-column-wont-adjust-when-i-set-font-size-through-css
            //
            // 	autoheight:true,
            // 	adjust : "data"
            //
            // }
        };
    }
    afterSaveError(id, status, response) { }
    getSelectedIdDoc() {
        let vv = this.currentGrid.getSelectedId(false, false);
        if (!vv) {
            webix.message((0, globals_1._)("Aucune ligne n'est sélectionnée"));
            return 0;
        }
        if (vv.length > 1) {
            webix.message((0, globals_1._)("Trop de lignes sélectionnées"));
            return 0;
        }
        let record = this.currentGrid.getItem(vv.row);
        return record.unid;
    }
    init(baseview) {
        let me = this;
        this.currentGrid = $$(this.datatableName);
        let dp = webix.dp(this.datatableName);
        this.searchField = $$("search");
        dp.attachEvent("onAfterInsert", function (response, id) {
            let record = me.currentGrid.getItem(id);
            // webix.message(response.message);
            if (!record.unid) {
                record.unid = response.unid;
                me.setDefaultValues(record);
                me.currentGrid.refresh();
            }
            me.currentGrid.select(id, false);
        });
        // Le traitement de onAfterSaveError est supprimé ici car il n'est pas compatible avec
        // son traitement dans la classe dérivée sauf à passer par des promises multiples
        // dp.attachEvent("onAfterSaveError", function(id, status, response) {
        // 	webix.alert({
        // 		text : (response.message),
        // 		modal : true
        // 	});
        // });
        dp.attachEvent("onAfterDelete", function (response, id, details) {
            // Cet événement n'est pas appelé pour status=error ou invalid !!!
            // En back end on utilise DeleteError
            if (!response.success) {
                // undo (ci-dessous) n'est pas utilisable car il appelle un insert
                // qui appelle lui-même un insertempty
                // me.currentGrid.undo(id);
                webix.alert({
                    text: (response.message)
                }).then(function () {
                    me.reload();
                });
            }
        });
        // je ne sais plus pourquoi j'ai mis ça (pdfjs ?), mais cela perturbe l'affichage des tests
        // if (navigator.webdriver) {
        // 	this.currentGrid.define("autoheight", true);
        // 	this.currentGrid.resize();
        // }
    }
}
exports.default = StdGrid;
